import script from "./MethodsBasic.vue?vue&type=script&setup=true&lang=ts"
export * from "./MethodsBasic.vue?vue&type=script&setup=true&lang=ts"

import "./MethodsBasic.vue?vue&type=style&index=0&id=e054ddca&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e054ddca"]])

export default __exports__